import { Search, X } from "lucide-react";
import { STATUS_LABELS, PRIORITAS_LABELS } from "../../data/programData";

export default function FilterBar({
  search,
  onSearch,
  status,
  onStatus,
  prioritas,
  onPrioritas,
  program,
  onProgram,
  programs,
  onReset,
}) {
  const hasFilters = search || status !== "ALL" || prioritas !== "ALL" || program !== "ALL";

  return (
    <div
      data-testid="filter-bar"
      className="flex flex-col gap-3 rounded-lg border border-gray-200 bg-white p-4 md:flex-row md:items-center"
    >
      <div className="relative flex-1">
        <Search className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <input
          data-testid="filter-search"
          type="text"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder="Cari nama sub-kegiatan…"
          className="h-9 w-full rounded-md border border-gray-300 bg-white pl-8 pr-3 text-[13px] text-slate-900 placeholder:text-slate-400 focus:border-[#1e3a5f] focus:outline-none focus:ring-2 focus:ring-[#1e3a5f]/20"
        />
      </div>

      <select
        data-testid="filter-status"
        value={status}
        onChange={(e) => onStatus(e.target.value)}
        className="h-9 rounded-md border border-gray-300 bg-white px-2.5 text-[13px] text-slate-800 focus:border-[#1e3a5f] focus:outline-none focus:ring-2 focus:ring-[#1e3a5f]/20"
      >
        <option value="ALL">Semua Status</option>
        {Object.entries(STATUS_LABELS).map(([k, v]) => (
          <option key={k} value={k}>
            {v}
          </option>
        ))}
      </select>

      <select
        data-testid="filter-prioritas"
        value={prioritas}
        onChange={(e) => onPrioritas(e.target.value)}
        className="h-9 rounded-md border border-gray-300 bg-white px-2.5 text-[13px] text-slate-800 focus:border-[#1e3a5f] focus:outline-none focus:ring-2 focus:ring-[#1e3a5f]/20"
      >
        <option value="ALL">Semua Prioritas</option>
        {Object.entries(PRIORITAS_LABELS).map(([k, v]) => (
          <option key={k} value={k}>
            {v}
          </option>
        ))}
      </select>

      <select
        data-testid="filter-program"
        value={program}
        onChange={(e) => onProgram(e.target.value)}
        className="h-9 min-w-[180px] rounded-md border border-gray-300 bg-white px-2.5 text-[13px] text-slate-800 focus:border-[#1e3a5f] focus:outline-none focus:ring-2 focus:ring-[#1e3a5f]/20"
      >
        <option value="ALL">Semua Program</option>
        {programs.map((p) => {
          const shortName = p.nama.length > 40 ? `${p.nama.slice(0, 40)}…` : p.nama;
          const label = `${p.kode} — ${shortName}`;
          return (
            <option key={p.id} value={p.id}>
              {label}
            </option>
          );
        })}
      </select>

      {hasFilters ? (
        <button
          type="button"
          onClick={onReset}
          data-testid="filter-reset"
          className="inline-flex h-9 items-center gap-1.5 rounded-md border border-gray-300 bg-white px-3 text-[12px] font-semibold text-slate-700 hover:border-[#1e3a5f] hover:text-[#1e3a5f]"
        >
          <X className="h-3.5 w-3.5" />
          Reset
        </button>
      ) : null}
    </div>
  );
}
